
export default {
  orsDictionary: {
    unknown: 'Desconhecido',
    paved: 'Pavimentado',
    unpaved: 'Não pavimentado',
    asphalt: 'Asfalto',
    concrete: 'Concreto',
    cobblestone: 'Pavimentação de pedra',
    metal: 'Metal',
    wood: 'Madeira',
    compactedGravel: 'Cascalho compactado',
    fineGravel: 'Cascalho fino',
    gravel: 'Cascalho',
    dirt: 'Estrada de terra',
    ground: 'Estrada de chão',
    ice: 'Gelo',
    pavingStones: 'Paralelepípedo',
    sand: 'Areia',
    woodchips: 'Cavacos de madeira',
    grass: 'Grama',
    grassPaver: 'Pavimentação com grama',
    none: 'Nenhum',
    no: 'Não',
    customers: 'Clientes',
    destination: 'Destinação',
    delivery: 'Entrega',
    private: 'Privado',
    permissive: 'Permissivo',
    stateRoad: 'Rodovia estadual',
    road: 'Rodovia',
    street: 'Rua',
    path: 'Caminho',
    track: 'trilha',
    cycleway: 'Ciclovia',
    footway: 'Passarela',
    steps: 'Degraus',
    ferry: 'Ferry',
    construction: 'Em construção',
    'concrete:lanes': 'Faixas de concreto',
    paving_stones: 'Calçamento de pedra',
    sett: 'Paralelepípedo',
    unhewn_cobblestone: 'Calçamento de pedra irregular',
    compacted: 'Compactado',
    fine_gravel: 'Cascalho fino',
    pebblestone: 'Pedras pequenas',
    impassable: 'Impassável',
    very_horrible: 'Muito horrível',
    horrible: 'Horrível',
    very_bad: 'Muito ruim',
    bad: 'Ruim',
    intermediate: 'Intermediário',
    good: 'Bom',
    excellent: 'Excelente',
    grade1: 'Nota 1',
    grade2: 'Nota 2',
    grade3: 'Nota 3',
    grade4: 'Nota 4',
    grade5: 'Nota 5',

    no_tollway: 'Não Pedagiada',
    is_tollway: 'Pedagiada',
    no_category: 'Sem categoria',
    highway: 'Via rápida',
    unpaved_road: 'Não asfaltada',
    tunnel:	'Túnel',
    paved_road:	'Asfaltada',
    ford: 'Passo de rio',
    no_data: 'Sem dados'
  }
}